"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CELL_VALUE_ERROR_COLUMN_TYPES = void 0;
exports.encodeCellValueError = encodeCellValueError;
exports.decodeCellValueError = decodeCellValueError;
const CELL_VALUE_ERROR_PREFIX = 'AUTOMATION_CELL_VALUE:';
exports.CELL_VALUE_ERROR_COLUMN_TYPES = [
    'date',
    'number',
    'select',
    'multi-select',
];
/**
 * Stable, value-free error payload for a value its target column cannot read;
 * UI translates it using the viewer's language.
 */
function encodeCellValueError(details) {
    return (CELL_VALUE_ERROR_PREFIX +
        JSON.stringify({
            columnName: details.columnName,
            columnType: details.columnType,
        }));
}
/**
 * Reads the first payload in the message. Row errors of one run are joined
 * into a single text, so the payload may be followed by further errors.
 */
function decodeCellValueError(message) {
    const start = message.indexOf(CELL_VALUE_ERROR_PREFIX);
    if (start < 0)
        return null;
    const payload = message.slice(start + CELL_VALUE_ERROR_PREFIX.length);
    for (let end = payload.indexOf('}'); end >= 0; end = payload.indexOf('}', end + 1)) {
        const details = parseDetails(payload.slice(0, end + 1));
        if (details)
            return details;
    }
    return null;
}
function parseDetails(text) {
    let parsed;
    try {
        parsed = JSON.parse(text);
    }
    catch {
        return null;
    }
    if (!parsed || typeof parsed !== 'object')
        return null;
    const value = parsed;
    const columnType = exports.CELL_VALUE_ERROR_COLUMN_TYPES.find(type => type === value.columnType);
    if (typeof value.columnName !== 'string' || !columnType)
        return null;
    return { columnName: value.columnName, columnType };
}
